import { FileBasic } from '@commenda/types/src/file/types';
import { fetcher } from '@commenda/utils';
import { MarketplaceServiceStatus } from '@prisma/client';

type UpdateCustomerMarketplaceServiceProps = {
  status?: MarketplaceServiceStatus;
  statusUpdateComment?: string;
  file?: FileBasic;
  caFirmId: string;
};

export async function updateCustomerMarketplaceService(
  customerMarketplaceServiceId: string,
  body: UpdateCustomerMarketplaceServiceProps,
  token?: string | undefined
) {
  const response = await fetcher(
    `marketplaceService/customerMarketplaceService/${customerMarketplaceServiceId}`,
    {
      method: 'POST',
      body: {
        caFirmId: body.caFirmId,
        ...(body.status ? { status: body.status } : {}),
        ...(body.file ? { files: [body.file] } : {}),
        ...(body?.statusUpdateComment
          ? { statusUpdateComment: body.statusUpdateComment }
          : {}),
      },
    },
    token
  );

  return response;
}
